import { render, staticRenderFns } from "./UserActions.vue?vue&type=template&id=2365d1d2&"
import script from "./UserActions.vue?vue&type=script&lang=js&"
export * from "./UserActions.vue?vue&type=script&lang=js&"
import style0 from "./UserActions.vue?vue&type=style&index=0&id=2365d1d2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports